/* My Quotes list (M6 read side).
 *
 * Reads /apps/dealer/quotes through the App Proxy — the proxy supplies the
 * verified customer, so the page never asserts who the dealer is.
 */
(function () {
  var app = document.getElementById('DealerQuotes');
  if (!app) return;

  var PROXY = app.dataset.proxyBase || '/apps/dealer';

  /* Records follow the dealer's chosen location (dealer-dashboard.js keeps the
   * choice), else the buyer's current Shopify location. The portal checks it
   * against the login, so it can only narrow what a login may see. */
  function scopeParam() {
    var chosen = '';
    try { chosen = localStorage.getItem('oew-dealer-scope') || ''; } catch (e) {}
    return chosen || app.dataset.location || '';
  }
  var DETAIL_URL = app.dataset.detailUrl || '/pages/order-detail';
  var PER_PAGE = parseInt(app.dataset.perPage, 10) || 10;

  var state = { status: 'open', page: 1, total: 0 };

  var money = function (n) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(n) || 0);
  };

  /* Date-only strings must not pass through new Date('YYYY-MM-DD') — that is
   * UTC midnight and shows yesterday in US timezones. */
  var parts = function (iso) { var p = String(iso || '').split('-'); return p.length === 3 ? p : null; };
  var day = function (iso) {
    var p = parts(iso);
    if (!p) return '';
    return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString('en-US',
      { month: 'short', day: 'numeric', year: 'numeric' });
  };

  var el = function (sel) { return app.querySelector(sel); };

  function cell(tr, cls, node) {
    var td = document.createElement('td');
    if (cls) td.className = cls;
    if (typeof node === 'string') td.textContent = node; else if (node) td.appendChild(node);
    tr.appendChild(td);
    return td;
  }

  function load() {
    var body = el('[data-quotes-body]');
    var msg = el('[data-quotes-message]');
    body.innerHTML = '';
    msg.hidden = false;
    msg.textContent = 'Loading quotes…';
    /* Mobile QA 2026-10-14 (M25): no table header while loading or when a tab is empty. */
    var wrap = app.querySelector('.dealer-orders__table-wrap');
    if (wrap) wrap.hidden = true;

    var params = new URLSearchParams({ page: state.page, per_page: PER_PAGE });
    if (scopeParam()) params.set('location', scopeParam());
    if (state.status) params.set('status', state.status);

    fetch(PROXY + '/quotes?' + params, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { msg.textContent = 'Something went wrong loading your quotes. Please try again.'; return; }

        var rows = res.body.quotes || [];
        state.total = res.body.total || 0;

        if (!rows.length) {
          msg.textContent = state.status
            ? 'No ' + (state.status === 'processed' ? 'converted' : state.status) + ' quotes. Check the other tabs, or ask your sales rep to prepare a quote.'
            : 'No quotes yet. Your sales rep can prepare a quote for you.';
          msg.classList.add('dealer-quotes__empty');
          renderPager();
          return;
        }
        msg.hidden = true;
        msg.classList.remove('dealer-quotes__empty');
        if (wrap) wrap.hidden = false;

        var today = new Date(); today.setHours(0, 0, 0, 0);

        /* Same pill convention as My Orders: modifier slug from the label. */
        var pillClass = function (label) {
          return 'dealer-orders__pill dealer-orders__pill--' +
            String(label || '').toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-|-$/g, '');
        };

        rows.forEach(function (q) {
          var tr = document.createElement('tr');

          cell(tr, null, '#' + q.quote_number);
          cell(tr, null, day(q.date));

          /* Expiry only matters while the quote is open. */
          if (q.status.code === 'A' && q.expires) {
            var p = parts(q.expires);
            var expired = p && new Date(+p[0], +p[1] - 1, +p[2]) < today;
            var span = document.createElement('span');
            span.className = expired ? 'dash-due dash-due--past' : '';
            span.textContent = day(q.expires);
            cell(tr, null, span);
          } else {
            cell(tr, 'is-empty', '—');
          }

          var label = q.status.code === 'B' ? 'Converted' : q.status.label;
          var st = document.createElement('span');
          st.className = pillClass(label);
          st.textContent = label;
          cell(tr, null, st);

          cell(tr, q.po ? null : 'is-empty', q.po || '—');
          cell(tr, 'is-right', money(q.total));

          /* A converted quote links to the order it became. */
          if (q.order) {
            var a = document.createElement('a');
            a.className = 'dealer-orders__link';
            a.href = DETAIL_URL + '?order=' + encodeURIComponent(q.order.id);
            a.textContent = '#' + q.order.number;
            cell(tr, null, a);
          } else {
            cell(tr, 'is-empty', '—');
          }

          body.appendChild(tr);
        });

        renderPager();
      })
      .catch(function () { msg.textContent = 'Something went wrong loading your quotes. Please try again.'; });
  }

  function renderPager() {
    var pager = el('[data-quotes-pager]');
    var pages = Math.max(1, Math.ceil(state.total / PER_PAGE));
    pager.hidden = pages < 2;
    el('[data-quotes-pageinfo]').textContent = 'Page ' + state.page + ' of ' + pages;
    pager.querySelector('[data-page="prev"]').disabled = state.page <= 1;
    pager.querySelector('[data-page="next"]').disabled = state.page >= pages;
  }

  el('[data-quotes-pager]').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-page]');
    if (!btn || btn.disabled) return;
    state.page += btn.dataset.page === 'next' ? 1 : -1;
    load();
  });

  el('[data-quote-filters]').addEventListener('click', function (e) {
    var tab = e.target.closest('[data-status]');
    if (!tab) return;
    state.status = tab.dataset.status;
    state.page = 1;
    Array.prototype.forEach.call(app.querySelectorAll('[data-quote-filters] .dealer-orders__tab'), function (t) {
      var active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    load();
  });

  load();
})();
